import { styled } from "styled-components";
import { BlueBirdTheme } from "@kitbird/core";
import rightCornerMediumBg from "../../assets/images/right_corner_medium_bg.svg";

export const ContentWrapper = styled.div`
  padding: 20px 20px 20px 40px;
  width: 100%;
  transition: all 0.3s;
  box-sizing: border-box;
  height: 100vh;

  overflow-y: auto;
`;

export const TitleContent = styled.div`
  img {
    width: 32px;
    height: 26px;
  }
  display: flex;
  gap: .5rem;
`;

export const PageWrapper = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const PageCard = styled.div`
  width: 100%;
  height: 90vh;
  background-color: ${BlueBirdTheme.colors.white};
  border-radius: 12px;
`;

export const MainPageCard = styled(PageCard)`
  height: calc(100vh - 72px - 24px - 72px);
`;

export const CardContent = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 1rem 24px 1rem 24px; 
`;

export const ListCountWrapper = styled.div`
  display: flex;
  gap: 9px;
  font-weight: 500;
  color: #58627a;
  align-items: center;
`;

export const ThemeBackground = styled.div`
  background-attachment: local;
  background-position: bottom right; 
  background-image: url(${rightCornerMediumBg});  
  background-repeat: no-repeat;
`;
